<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
        ref="table"
        v-model="selected"
        pagination
        search
        :data="categories">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
            <h1 class="mr-2">Product categorieën <span v-if="staffRoute">bij {{ $route.params.slug | title('-') }}</span></h1>
        </div>
      </div>

      <template slot="thead">
        <vs-th>Afbeelding</vs-th>
        <vs-th sort-key="name">Naam</vs-th>
        <vs-th sort-key="description">Beschrijving</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="img-container">
              <img :src="tr.image" class="product-img" />
            </vs-td>

            <vs-td>
              <p class="order-id font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="order-description">{{ tr.description }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="$router.push({'name': 'companies-product-categories-edit', params: {'slug': $route.params.slug, 'category': tr.id}})" />
              <feather-icon class="ml-2" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="deleteDialog(tr)" />
            </vs-td>

          </vs-tr>
        </tbody>
        <!-- <ht-product-popup></ht-product-popup> -->

      </template>
    </vs-table>
    <div @click="addNewData">
      <fab
              position="bottom-right"
              bg-color="#00420D"
      ></fab>
    </div>
  </div>
</template>

<script>
  // import ProductPopup from '../ProductPopup'

export default {
  components: {
    // 'ht-product-popup': ProductPopup
  },
  created () {

  },
  mounted () {
    this.isMounted = true
    this.getCategories();
  },
  data () {
    return {
      selected: [],
      categories: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      total: 0,
      activeOrder: null,
      popupActive: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.categories.length
    },
    staffRoute () {
      if(this.$route.meta.staff) {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
      } else {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
        return false
      }
    },
    activeProductTitle: function () {
      if (this.activeProduct !== null) {
        return 'Bestelnummer #' + this.activeProduct.id;
      }
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if(to.params.slug !== null) {
        this.getCategories();
      }
    },
  },
  methods: {
    getCategories () {
      let url = this.staffRoute ? 'v1/company/'+ this.$route.params.slug +'/product-categories' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-categories'
      let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'))
      this.$http.get(url, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then((response) => {
        this.categories = this.staffRoute ? response.data.data : response.data;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      })
    },
    deleteDialog (category) {
        if(confirm('Weet u zeker dat u ' + category.name + ' wilt verwijderen!')) {
            this.deleteCategory(category.id);
        }
    },
    deleteCategory (id) {
        let formData = new FormData();

        formData.append('_method', 'DELETE');
        formData.append('id', id);

        let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
        let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-category/delete' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-category/delete'
        this.$http.post(url, formData,
        {
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            console.log(response)
            this.$vs.notify({
                title: 'Success',
                text: 'Succesvol opgeslagen',
                color: 'success'
            });
            this.getCategories();
        }).catch((error) => {
          this.$util.logError(error, this.$vs);
        })

    },
    addNewData () {
        this.$router.push({'name': 'companies-product-categories-create'})
    },
    editData (data) {
      this.$events.fire('open-product-modal', data)
    },
    getCategoriestatusColor (status) {
        if (status === 'on_hold')   return 'warning'
        if (status === 'delivered') return 'success'
        if (status === 'canceled')  return 'danger'
        return 'primary'
    },
    getPopularityColor (num) {
        if (num > 90)  return 'success'
        if (num > 70)  return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50)  return 'danger'
        return 'primary'
    },
    toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
    },
    getStatus(status) {
        if(status == 0) {
            return 'inactief';
        }
        if(status == 1) {
            return 'open';
        }
        if(status == 2) {
            return 'gesloten';
        }
        if(status == 3) {
            return 'Tijdelijk gesloten';
        }
        if(status == 4) {
            return 'Binnenkort geopend';
        }
    }
  },
}
</script>

<style lang="scss">
  #data-list-thumb-view {
    h1 {
      padding-bottom: 15px;
      margin-left: 20px;
    }
  .vs-con-table {

    .order-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              width: 1rem;
              background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .order-img {
                max-height: 100px;
                max-width: 100px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
